// extracted by mini-css-extract-plugin
export default {"icons":"TasksFilters_icons__rky2Y","selected-icons":"TasksFilters_selected-icons__W9XD8","add-icon":"TasksFilters_add-icon__bFRgC","icon-24":"TasksFilters_icon-24__ks0qz"};